import { ACCEPTANCE_CRITERIA_OPTION } from '@src/features/shift-post-v2/steps/acceptance-criteria-step/acceptance-criteria-step.types'

export const RADIO_OPTIONS = [
  {
    value: ACCEPTANCE_CRITERIA_OPTION.VERIFIED,
    title: 'Verified Upshifters',
    description:
      'Access our full pool of qualified and verified Upshifters who meet your shift requirements.',
  },
  {
    value: ACCEPTANCE_CRITERIA_OPTION.VERIFIED_FROM_ROSTERS,
    title: 'Verified Upshifters from your Rosters',
    description:
      'Only Upshifters from your rosters will be able to claim this shift.',
  },
  {
    value: ACCEPTANCE_CRITERIA_OPTION.PERSONALLY_APPROVED,
    title: 'Personally Approved Upshifters',
    description:
      "Review and approve each Upshifter's application before they can claim the shift.",
  },
]
